<template>
  <v-flex class="articles-page">
    <v-row justify="center">
      <v-col cols="12">
        <!-- Modern Header Section -->
        <div class="page-header mb-6">
          <v-row justify="center" align="center" class="px-6 pt-4">
            <v-col cols="12" class="text-center">
              <div class="d-inline-flex align-center mb-2">
                <v-avatar size="56" color="primary lighten-5" class="mr-4">
                  <v-icon color="primary" size="30">mdi-package-variant-closed</v-icon>
                </v-avatar>
                <div class="text-left">
                  <h1 class="text-h4 font-weight-black grey--text text--darken-4 mb-0">
                    Productos y Servicios
                  </h1>
                  <p class="text-body-2 grey--text mb-0">
                    Crea, edita y administra cada detalle de los productos y servicios
                  </p>
                </div>
              </div>
            </v-col>
          </v-row>
        </div>

        <!-- Article filters component -->
        <article_filters @newArticle="showNewArticle()" @getItemToEdit="editArticle" :dial="false"
          :showButonNewArticle="true" :typeView="false" v-if="updateArticle" />
      </v-col>
    </v-row>

    <v-dialog v-model="dialogArticle" fullscreen persistent>
      <v-card outlined color="#F4F5FB">
        <v-card-title>
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" small @click="showBar = !showBar" v-click-outside="onClickOutside"
                color="primary" class="mr-3 rounded-lg" depressed>
                <v-icon>{{ showBar == false ? "mdi-menu" : "mdi-menu-open" }}</v-icon>
              </v-btn>
            </template>
            <span>{{ showBar == false ? "Ver menú" : "Ocultar menú" }}</span>
          </v-tooltip>

          <div class="d-flex align-center">
            <v-avatar v-if="newItem.item_type" size="36" color="primary lighten-4" class="mr-3">
              <v-icon color="primary" size="18">mdi-package-variant</v-icon>
            </v-avatar>
            <span class="text-h6 font-weight-bold grey--text text--darken-3">{{ dialogTitle }}</span>
          </div>

          <v-spacer></v-spacer>

          <v-btn icon @click="dialogArticle = false" class="rounded-lg">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <NavigationButonsTop :showBar="showBar" />
          <v-container>
            <v-row justify="center">
              <v-col cols="12" md="8" class="pb-0 mb-0">
                <v-card outlined class="pt-0 mt-0" height="80vh">
                  <v-card-text>
                    <v-container fluid>
                      <v-row justify="space-around" class="pb-2">
                        <v-col v-for="item in itemTypes" cols="10" align="center" justify="center" md="2" class="px-1"
                          :key="item.id">
                          <v-btn block class="pa-2" :color="showCheckItemType(item) == true
                            ? 'secondary'
                            : 'primary'
                            " @click="typeSelected(item)" label :outlined="!showCheckItemType(item)"
                            :disabled="is_item_edit">
                            {{ item.name }}
                            <!-- <v-icon
                              color="success"
                              small
                              v-show="showCheckItemType(item)"
                              >task_alt</v-icon 
                            >-->
                          </v-btn>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="12" md="8" class="pt-0 mt-0 pb-0">

                          <v-text-field class="text-xs-center" v-model="newItem.name" label="Nombre" dense outlined
                            :readonly="can_edit_item">
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" md="4" class="pt-0 mt-0 pb-0">
                          <v-autocomplete v-model="newItem.item_category" :items="categorys" item-value="id"
                            item-text="name" return-object color="cyanText" label="Categoria" outlined required dense>
                          </v-autocomplete>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="3" md="4" class="pt-0 mt-0 pb-0">
                          <v-autocomplete v-model="newItem.unit" :items="units" item-value="id" item-text="name"
                            return-object color="cyanText" label="Unidad de medida" outlined required dense>
                          </v-autocomplete>
                        </v-col>
                        <!-- <v-col cols="12" md="4" class="pt-0 mt-0 pb-0">
                          <v-autocomplete
                            v-model="newItem.account_category"
                            :items="accountCategorys"
                            item-value="id"
                            item-text="name"
                            return-object
                            color="cyanText"
                            label="Cuenta contable"
                            outlined
                            required
                            dense
                          >
                          </v-autocomplete>
                        </v-col> -->
                        <!-- <v-col cols="12" md="4" class="pt-0 mt-0 pb-0">
                          <v-autocomplete
                            v-model="newItem.tax_type"
                            :items="taxes"
                            item-value="id"
                            item-text="name"
                            return-object
                            color="cyanText"
                            label="Tipo de impuesto"
                            outlined
                            required
                            dense
                          >
                          </v-autocomplete>
                        </v-col> -->
                      </v-row>
                      <v-row>
                        <v-col cols="12" md="12" class="pt-0 mt-0 pb-0">
                          <v-textarea class="text-xs-center" v-model="newItem.note" label="Nota" dense auto-grow
                            outlined rows="3">
                          </v-textarea>
                        </v-col>
                      </v-row>
                      <v-row justify="center">
                        <v-col cols="12" sm="10" md="12" class="pa-0">
                          <template>
                            <v-tabs v-model="tab" align-with-title class="d-flex justify-center">
                              <v-tabs-slider color="primary"></v-tabs-slider>
                              <v-tab>{{ variant_title }}</v-tab>
                              <v-tab @click="getAltitemRecipes" v-if="variant_title != 'Variante'">Recetas</v-tab>
                              <v-tab @click="getAlternatives" :loading="loadingAlternatives">Alternativas</v-tab>
                            </v-tabs>
                          </template>
                          <v-tabs-items v-model="tab">
                            <!-- Variantes----------------------------------------------------------- -->
                            <v-tab-item href="#tab-0">
                              <v-container fluid>
                                <v-card outlined>
                                  <v-simple-table v-if="variant_title == 'Variantes'">
                                    <template v-slot:default>
                                      <thead></thead>
                                      <tbody>
                                        <tr>
                                          <td>
                                            <template>
                                              <v-list class="pa-0">
                                                <v-list-item @click="openDialogVariants()" width="100%">
                                                  <v-list-item-title class="d-flex justify-center align-center">
                                                    <v-icon class="pr-2">settings</v-icon>
                                                    Configurar variantes
                                                  </v-list-item-title>
                                                </v-list-item>
                                              </v-list>
                                            </template>
                                          </td>
                                        </tr>
                                        <tr v-for="item in convinaciones" :key="item.id">
                                          <td>
                                            <v-icon color="grey lighten-1" large @click="addPhoto(item)">
                                              add_a_photo
                                            </v-icon>
                                            <span class="ml-3 mt-3">{{
                                              item.name
                                              }}</span>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </template>
                                  </v-simple-table>
                                  <v-simple-table v-if="variant_title == 'Variante'">
                                    <template v-slot:default>
                                      <thead></thead>
                                      <tbody>
                                        <tr v-for="item in newItem.item_attributes" :key="item.variants.variant_id">
                                          <td class="d-flex justify-center align-center">
                                            <span class="ml-3 mt-3">{{
                                              item.variants.variant_name +
                                              ": " +
                                              item.variants
                                                .variant_attribute_name
                                            }}</span>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </template>
                                  </v-simple-table>
                                </v-card>
                              </v-container>
                            </v-tab-item>
                            <!-- Recetas----------------------------------------------------------- -->
                            <v-tab-item href="#tab-1" v-if="variant_title != 'Variante'">
                              <v-container fluid>
                                <v-card outlined>
                                  <template>
                                    <v-list class="pa-0">
                                      <v-list-item @click="openDialogToSelectItem(1)" width="100%">
                                        <v-list-item-title class="d-flex justify-center align-center">
                                          <v-icon class="pr-2" color="success">add</v-icon>
                                          Agregar receta
                                        </v-list-item-title>
                                      </v-list-item>
                                    </v-list>
                                  </template>
                                  <v-simple-table outlined>
                                    <template v-slot:default>
                                      <thead>
                                        <tr>
                                          <th class="text-center">ID</th>
                                          <th class="text-center">
                                            Descripcion
                                          </th>
                                          <th class="text-center">Cantidad</th>
                                          <th class="text-center">Nota</th>
                                          <th class="text-center">Remover</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr v-for="item in item_in_recipes" :key="item.item_id">
                                          <td>
                                            <span class="d-flex justify-center align-center">{{ item.item_id }}</span>
                                          </td>
                                          <td>
                                            <span class="d-flex justify-center align-center">{{ item.item_name }}</span>
                                          </td>
                                          <td width="10%">
                                            <v-text-field type="number" min="1" class="text-xs-center"
                                              v-model="item.quantity" dense>
                                            </v-text-field>
                                          </td>
                                          <td width="15%">
                                            <v-tooltip top>
                                              <template v-slot:activator="{ on, attrs }">
                                                <v-text-field v-bind="attrs" v-on="on" class="text-xs-center"
                                                  v-model="item.item_note" dense>
                                                </v-text-field>
                                              </template>
                                              <span>{{ item.item_note }}</span>
                                            </v-tooltip>
                                          </td>
                                          <td class="d-flex justify-center align-center">
                                            <v-btn text color="error" @click="removeRecipes(item)">
                                              Quitar
                                            </v-btn>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </template>
                                  </v-simple-table>
                                </v-card>
                              </v-container>
                            </v-tab-item>
                            <!-- Alternativas----------------------------------------------------------- -->
                            <v-tab-item href="#tab-2">
                              <v-container fluid>
                                <v-card outlined>
                                  <template>
                                    <v-list class="pa-0">
                                      <v-list-item @click="openDialogToSelectItem(2)" width="100%">
                                        <v-list-item-title class="d-flex justify-center align-center">
                                          <v-icon class="pr-2" color="success">add</v-icon>
                                          Agregar alternativa
                                        </v-list-item-title>
                                      </v-list-item>
                                    </v-list>
                                  </template>
                                  <v-simple-table outlined>
                                    <template v-slot:default>
                                      <thead>
                                        <tr>
                                          <th class="text-center">Codigo</th>
                                          <th class="text-center">
                                            Descripcion
                                          </th>
                                          <th class="text-center">Nota</th>
                                          <th class="text-center">Remover</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr v-for="item in item_in_alternatives" :key="item.item_id">
                                          <td>
                                            <span class="d-flex justify-center align-center">{{ item.item_id }}</span>
                                          </td>
                                          <td>
                                            <span class="d-flex justify-center align-center">{{ item.item_name }}</span>
                                          </td>
                                          <td width="15%">
                                            <v-tooltip top>
                                              <template v-slot:activator="{ on, attrs }">
                                                <v-text-field v-bind="attrs" v-on="on" class="text-xs-center"
                                                  v-model="item.item_note" dense>
                                                </v-text-field>
                                              </template>
                                              <span>{{ item.item_note }}</span>
                                            </v-tooltip>
                                          </td>
                                          <td>
                                            <v-icon class="d-flex justify-center align-center" color="error"
                                              @click="removeAlternative(item)">cancel</v-icon>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </template>
                                  </v-simple-table>
                                </v-card>
                              </v-container>
                            </v-tab-item>
                          </v-tabs-items>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" md="4" class="pb-0 mb-0">
                <v-card width="100%" outlined height="80vh">
                  <v-hover v-slot="{ hover }">
                    <v-card flat height="200" :class="hover ? 'grey lighten-3' : 'grey lighten-4'">
                      <v-img contain :src="item_image" height="200">
                        <v-container fill-height fluid>
                          <v-row align="center" justify="center">
                            <v-col cols="12" md="2" align="center">
                              <v-file-input v-show="item_image == null ? true : hover" v-model="url_image"
                                @change="takeImage" name="upload" id="fileInput"
                                accept="image/png, image/jpeg, image/jpg" :prepend-icon="item_image == null
                                  ? 'add_a_photo'
                                  : 'cameraswitch'
                                  " hide-details hide-input hide-spin-buttons></v-file-input>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-img>
                      <!-- <v-icon color="grey lighten-2" x-large>add_a_photo</v-icon> -->
                      <!-- <v-container fill-height fluid>
                        <v-row align="center" justify="center">
                          <v-col cols="12" md="2" align="center">
                              <v-file-input
                              v-model="url_image"
                              @change="takeImage"
                              name="upload"
                              id="fileInput"
                              accept="image/png, image/jpeg, image/jpg"
                              prepend-icon="add_a_photo"
                              hide-details
                              hide-input
                              hide-spin-buttons
                            ></v-file-input>
                          </v-col>
                        </v-row>
                      </v-container> -->
                    </v-card>
                  </v-hover>
                  <v-card flat>
                    <v-container fluid>
                      <span :style="`color:#757575;font-size:18px`" large>{{
                        textNomber
                        }}</span>
                      <br />
                      <br />
                      <span :style="`color:#757575;font-size:18px`" large>Variantes: {{ convinaciones.length }}
                      </span>
                      <!-- <v-switch
                        v-model="newItem.inventory_product"
                        label="Inventariable"
                      ></v-switch> -->
                      <v-switch v-model="newItem.negative_sale" label="Venta en negativo" class="mt-0 mb-0 pb-0">
                      </v-switch>
                      <v-switch v-model="newItem.editable" label="Editable" class="mt-0 mb-0 pb-0">
                      </v-switch>

                    </v-container>
                  </v-card>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="success" text @click="saveArticle" :disabled="isSaving || can_edit_item" :loading="isSaving">
                      Guardar
                    </v-btn>
                    <v-btn color="error" text @click="dialogArticle = false">
                      Cancelar
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogVariants" max-width="60%">
      <v-card outlined>
        <v-card-title class="mb-3">
          <span>Configuracion de variantes</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogVariants = false">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container fluid>
            <v-row>
              <v-col cols="12" md="5">
                <v-card outlined>
                  <v-container fluid>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead></thead>
                        <tbody>
                          <tr v-for="item in variants" :key="item.id" @click="selectVariant(item)" :class="item.selected == true ? 'blue-grey lighten-5' : ''
                            ">
                            <td>{{ item.name }}</td>
                            <td>
                              <v-switch v-model="item.include"></v-switch>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-container>
                </v-card>
              </v-col>
              <v-col cols="12" md="7">
                <v-card color="gray" outlined>
                  <v-container fluid>
                    <v-data-table v-model="subSelected" :items="subVariantes" :headers="subVariantsHeader"
                      hide-default-footer hide-default-header :single-select="singleSelect" :items-per-page="100"
                      item-key="sequence" @item-selected="selectSubVariant" show-select>
                    </v-data-table>
                  </v-container>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" text @click="generarConvinaciones()">
            Guardar
          </v-btn>
          <v-btn color="error" text @click="dialogVariants = false">
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogAddAlternative" v-if="dialogAddAlternative" max-width="75%" persistent>
      <v-card>
        <v-card-title>
          <v-icon>add</v-icon>
          <span class="headline">Escoger articulos a agregar</span>
          <v-spacer></v-spacer>
          <v-menu bottom left>
            <template v-slot:activator="{ }">
              <v-btn icon @click="dialogAddAlternative = false">
                <v-icon>clear</v-icon>
              </v-btn>
            </template>
          </v-menu>
        </v-card-title>
        <v-card-text>
          <v-row justify="center">
            <article_filters @getItemToEdit="addItemSelected" :dial="false" icon="done" name="Agregar"
              startFilter=" WHERE ITEM_TYPE_ID<>2 " />
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" text @click="dialogAddAlternative = false">
            <v-icon> done </v-icon>
            Aceptar
          </v-btn>
          <v-btn color="red darken-1" text @click="dialogAddAlternative = false">
            <v-icon> clear </v-icon>
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-flex>
</template>
<script>
import article_filters from "@/components/Inventory/ArticleSelectionList.vue";//here
import NavigationButonsTop from "@/components/Inventory/NavigationButonsTop.vue";
export default {
  data() {
    return {
      subSelected: [],
      singleSelect: false,
      dialogAddAlternative: false,
      dialogArticle: false,
      dialogVariants: false,
      variants: [],
      subVariantsHeader: [{ text: "", value: "name" }],
      subVariantes: [],
      convinaciones: [],
      newItem: {
        item_id: null,
        name: "",
        unit: "",
        item_type: "",
        item_category: "",
        account_category: "",
        tax_type: "",
        inventory_product: true,
        negative_sale: false,
        editable: false,
        note: "",
        image_url: null,
      },
      item_in_alternatives: [],
      item_in_recipes: [],
      units: [],
      itemTypes: [],
      categorys: [],
      accountCategorys: [],
      taxes: [],
      tab: null,
      is_item_edit: false,
      dialog_is_alternative: false,
      loadingAlternatives: false,
      item_image: null,
      url_image: null,
      updateArticle: true,
      changeImage: false,
      showBar: false,
      isSaving: false,
    };
  },
  created() {
    this.getData();
  },
  components: {
    article_filters,
    NavigationButonsTop,
  },
  computed: {
    dialogTitle() {
      return this.is_item_edit == true
        ? this.firtsLetterMinRestUp("Editar " + this.newItem.item_type.name) +
        " #" +
        this.newItem.item_id
        : "Nuevo Producto/Servicio";
    },
    textNomber() {
      if (this.newItem.name == "") {
        return this.firtsLetterMinRestUp(
          this.newItem.item_type.name + " sin nombre"
        );
      } else {
        return this.firtsLetterMinRestUp(this.newItem.name + " ");
      }
    },
    variant_title() {
      if (this.newItem.item_type == "") {
        return "Variantes";
      }
      return this.newItem.item_type.id == 5 ? "Variante" : "Variantes";
    },
    can_edit_item() {
      if (this.newItem.is_internal) {
        return true;
      }
      if (this.newItem.item_id == null) {
        return false;
      }
      if (this.$store.state.auth.globalFeatures.includes('INV-021')) {
        return false;
      }
      return true;
    }
  },
  methods: {
    async getData() {
      const result = await Promise.all([
        this.api_Get("inventory/units"),
        this.api_Get("inventory/itemTypes"),
        this.api_Get("accounting/taxes"),
        this.api_Get("inventory/categories"),
        this.api_Get("accounting/account_categories"),
        this.api_Get("inventory/variants"),
      ]);

      //----------------UNIDADES--------------------

      this.units = await result[0].json();
      //----------------ITEM TYPES--------------------
      this.itemTypes = await result[1].json();
      this.newItem.item_type = this.itemTypes[0];
      //----------------TAXES-------------------------
      this.taxes = await result[2].json();
      this.newItem.tax_type = this.taxes[0];
      //----------------CATEGORYS-------------------------

      const categories = await result[3].json();
      this.categorys = categories.filter((element) => element.parent_category_id == null);
      //----------------ACCOUNT CATEGORYS-------------------------

      this.accountCategorys = await result[4].json();
      //----------------VARIANTES-----------------------------------

      const data = await result[5].json();
      for (let item of data) {
        this.variants.push({
          id: item.id,
          name: item.name,
          subVariantes: item.variants_details,
          selected: false,
        });
      }
    },
    showNewArticle() {
      this.clearArticle()
      this.dialogArticle = true
    },
    selectSubVariant(subElement) {
      for (let keyVariant in this.variants) {
        for (let keySubVariant in this.variants[keyVariant].subVariantes) {
          if (
            this.variants[keyVariant].subVariantes[keySubVariant].sequence ==
            subElement.item.sequence
          ) {
            this.variants[keyVariant].subVariantes[keySubVariant].selected =
              subElement.value;
          }
        }
      }
    },
    selectVariant(variante) {
      let indice = this.variants.indexOf(variante);
      for (let key in this.variants) {
        this.variants[key].selected = indice == key ? true : false;
      }
      this.subVariantes = variante.subVariantes;
      this.subSelected = [];
      for (let keyVariant in this.variants) {
        for (let keySubVariant in this.variants[keyVariant].subVariantes) {
          if (
            this.variants[keyVariant].subVariantes[keySubVariant].selected ==
            true &&
            this.variants[keyVariant].id == variante.id
          ) {
            this.subSelected.push(
              this.variants[keyVariant].subVariantes[keySubVariant]
            );
          }
        }
      }
    },
    generarConvinaciones() {
      this.convinaciones = [];

      //apaga los switch de las variantes que no se hayan incluido subvaraintes
      for (let key in this.variants) {
        if (this.variants[key].include == true) {
          let countSb = this.variants[key].subVariantes.filter(
            (element) => element.selected == true
          );
          if (countSb.length == 0) {
            this.variants[key].include = false;
          }
        }
      }
      let countsVariants = this.variants.filter(
        (element) => element.include == true
      );
      if (countsVariants.length == 0) {
        this.$toast.warning("Debe agregar al menos una variante!");
        return;
      }
      let arrayCantXsubVariant = [];
      for (let item of countsVariants) {
        let countSb = item.subVariantes.filter(
          (element) => element.selected == true
        );
        arrayCantXsubVariant.push(countSb.length);
      }

      const cantidaTotalConvinaciones = arrayCantXsubVariant.reduce(
        (p, c) => p * c
      );
      for (let subA of countsVariants[0].subVariantes) {
        if (subA.selected == true) {
          for (
            let setInitVariant = 1;
            setInitVariant <=
            cantidaTotalConvinaciones / arrayCantXsubVariant[0];
            setInitVariant++
          ) {
            this.convinaciones.push({
              name: this.newItem.name + " / " + subA.name,
              variantSet: [subA.sequence],
            });
          }
        }
      }
      countsVariants = countsVariants.splice(1);
      for (let variantsToAdd of countsVariants) {
        let arraySubVariant = [];
        for (let subVariantAdd of variantsToAdd.subVariantes) {
          if (subVariantAdd.selected == true) {
            arraySubVariant.push(subVariantAdd);
          }
        }
        this.addSubVariantConvinations(arraySubVariant);
      }
      this.dialogVariants = false;
    },
    addSubVariantConvinations(arraySubVariant) {
      let keySubVariante = 1;
      for (let keyConvinations in this.convinaciones) {
        if (keySubVariante > arraySubVariant.length) {
          keySubVariante = 1;
        }
        this.convinaciones[keyConvinations].name +=
          " / " + arraySubVariant[keySubVariante - 1].name;
        this.convinaciones[keyConvinations].variantSet.push(
          arraySubVariant[keySubVariante - 1].sequence
        );
        keySubVariante++;
      }
    },
    addPhoto(item) { },
    takeImage() {
      if (this.url_image == null || this.url_image == undefined) {
        return;
      }
      this.item_image = URL.createObjectURL(this.url_image);
      this.changeImage = true;
    },
    openDialogVariants() {
      if (this.newItem.name == "") {
        this.$toast.warning("Indique el nombre del producto!");

        return;
      }
      this.dialogVariants = true;
    },

    editArticle(item) {
      this.is_item_edit = true;
      this.changeImage = false;
      this.newItem = {
        name: item.item_name,
        is_internal: item.is_internal,
        unit: this.units.find((element) => element.id == item.unit_id),
        item_type: this.itemTypes.find(
          (element) => element.id == item.item_type_id
        ),
        item_category: this.categorys.find(
          (element) => element.id == item.item_category_id
        ),
        account_category: this.accountCategorys.find(
          (element) => element.id == item.account_category_id
        ),
        tax_type: this.taxes.find((element) => element.id == item.tax_type_id),
        inventory_product: item.inventory_product,
        negative_sale: item.negative_sale,
        editable: item.editable,
        note: item.item_note,
        image_url: item.item_image_url,
        image_json: item.image_json,
        item_id: item.item_id,
        active: item.active,
        item_attributes: item.item_attributes,
      };
      this.getNewImage(item.image_json);
      this.tab = 0;
      this.dialogArticle = true;
    },
    async getNewImage(image) {

      if (image == null) {

        this.item_image = null
        this.url_image = null
        return
      }
      this.item_image = this.get_storage(image);
    },
    async saveArticle() {
      if (this.isSaving) return;
      this.newItem.name = (this.newItem.name || "").trim().replace(/\s+/g, " ");
      if (this.newItem.name == "") {
        this.$toast.warning("Indique el nombre del articulo!");
        return;
      }
      if (this.newItem.item_category.id == undefined) {
        this.$toast.warning("Indique la categoria del articulo!");
        return;
      }

      // if (this.newItem.account_category.id == undefined) {
      //   this.$toast.warning("Indique la categoria de cuenta del articulo!");
      //   return;
      // }
      if (this.newItem.unit.id == undefined) {
        this.$toast.warning("Indique la unidad de medida del articulo!");
        return;
      }
      this.isSaving = true;
      this.updateArticle = false;
      // if (this.newItem.image_url != null && this.newItem.image_url != "null") {
      //   await this.delete_file_storage("items_images", this.newItem.image_url);
      // }
      let record = null;
      if (this.changeImage == true && this.url_image) {
        try {
          record = await this.upload_to_spaces(this.url_image, "items");
          if (!record || !record.key) {
            this.$toast.error("Error al subir la imagen: respuesta vacía del servidor");
            this.isSaving = false;
            this.updateArticle = true;
            return;
          }
        } catch (uploadErr) {
          this.$toast.error("Error al subir la imagen: " + uploadErr.message);
          this.isSaving = false;
          this.updateArticle = true;
          return;
        }
      }
      if (this.newItem.note != null) {
        this.newItem.note = this.newItem.note.trim();
      }
      if (this.newItem.note == "") {
        this.newItem.note = null;
      }
      let articleData = {
        item_id: this.newItem.item_id,
        unit_id: this.newItem.unit.id,
        item_type_id: this.newItem.item_type.id,
        name: this.newItem.name,
        note: this.newItem.note,
        image_url: '',
        image_json: record != null ? record : this.newItem.image_json,
        variants: this.newItem.item_type.id == 5 ? null : this.convinaciones,
        // tax_type_id: this.newItem.tax_type.id,
        item_in_recipes: null,
        item_in_alternatives: null,

        negative_sale: this.newItem.negative_sale,
        editable: this.newItem.editable,
        // account_category_id: this.newItem.account_category.id,
        item_category_id: this.newItem.item_category.id,
        created_by: this.$store.state.auth.user.user.user_id
      };

      if (this.item_in_alternatives.length > 0) {
        articleData.item_in_alternatives = [];

        for (let item of this.item_in_alternatives) {
          articleData.item_in_alternatives.push({
            child_item_id: item.item_id,
            note: item.item_note,
          });
        }
      }
      if (this.item_in_recipes.length > 0) {
        articleData.item_in_recipes = [];

        for (let item of this.item_in_recipes) {
          articleData.item_in_recipes.push({
            child_item_id: item.item_id,
            note: item.item_note,
            quantity: item.quantity,
          });
        }
      }

      try {
        const request = await this.api_Post(
          "inventory/addOrUpdateItem",
          articleData
        );
        const data = await request.json();
        if (request.status == 200) {
          this.$toast.success("Registro realizado con exito!");
          this.dialogArticle = false;
          this.clearArticle()
        } else {
          if (request.status == 409) {
            this.$toast.warning(data.message);
          } else {
            this.$toast.error(data.message || data.error || "Error al guardar el articulo!");
          }
          if (record != null) {
            await this.delete_file_storage("items_images", record.id);
          }
        }
      } catch (error) {
        this.$toast.error("Error al guardar el articulo!");
      }
      this.isSaving = false;
      this.updateArticle = true;
    },
    typeSelected(item) {
      if (this.is_item_edit == true) {
        return;
      }
      this.newItem.item_type = item;
    },
    showCheckItemType(type) {
      if (type.id == this.newItem.item_type.id) {
        return true;
      } else {
        return false;
      }
    },
    clearArticle() {
      this.item_image = null;
      this.url_image = null
      this.newItem = {
        item_id: null,
        name: "",
        unit: "",
        item_type: this.itemTypes[0],
        item_category: "",
        account_category: "",
        tax_type: this.taxes[0],
        inventory_product: true,
        negative_sale: false,
        editable: false,
        note: "",
        image_url: null,
        image_json: null,
      };
      this.item_in_alternatives = [];
      this.item_in_recipes = [];
      this.convinaciones = [];
      this.tab = 0;
      this.is_item_edit = false;

      this.dialogArticle = false;

      this.changeImage = false;
    },
    addItemSelected(item) {
      if (this.dialog_is_alternative == true) {
        let is_selected = this.item_in_alternatives.find(
          (element) => element.item_id == item.item_id
        );
        if (is_selected != undefined) {
          this.$toast.warning(
            "Este articulo ya fue agregado como alternativa!"
          );
          return;
        }
        this.item_in_alternatives.push(item);
      } else {
        let is_selected = this.item_in_recipes.find(
          (element) => element.item_id == item.item_id
        );
        if (is_selected != undefined) {
          this.$toast.warning("Este articulo ya fue agregado como receta!");
          return;
        }

        this.item_in_recipes.push({
          item_id: item.item_id,
          item_name: item.item_name,
          item_note: item.item_note,
          quantity: 1,
        });
      }
      this.dialogAddAlternative = false;
      this.$toast.info(item.item_name + " agregado!");
    },
    removeAlternative(item) {
      let indice = this.item_in_alternatives.indexOf(item);
      this.item_in_alternatives.splice(indice, 1);
    },
    removeRecipes(item) {
      let indice = this.item_in_recipes.indexOf(item);
      this.item_in_recipes.splice(indice, 1);
    },
    async getAlternatives() {
      this.loadingAlternatives = true;
      try {
        const request = await this.api_Get(
          "inventory/item_alternative/" + this.newItem.item_id
        );
        if (request.status == 200) {
          const data = await request.json();
          this.item_in_alternatives = data;
        }
      } catch (error) {
        this.$toast.error(error);
      }
      this.loadingAlternatives = false;
    },
    async getAltitemRecipes() {
      try {
        const request = await this.api_Get(
          "inventory/item_recipes/" + this.newItem.item_id
        );
        if (request.status == 200) {
          const data = await request.json();
          this.item_in_recipes = data;
        }
      } catch (error) {
        this.$toast.error(error);
      }
    },
    openDialogToSelectItem(type) {
      if (type == 1) {
        this.dialog_is_alternative = false;
      } else {
        this.dialog_is_alternative = true;
      }

      this.dialogAddAlternative = true;
    },
    onClickOutside() {
      this.showBar = false;
    },
  },
};
</script>
<style scoped>
.articles-page {
  background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
  min-height: 100vh;
}

.page-header {
  background: linear-gradient(135deg, rgba(25, 118, 210, 0.03) 0%, rgba(255, 255, 255, 0) 100%);
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  padding-bottom: 16px;
}

.page-header h1 {
  letter-spacing: -0.5px;
}

/* Card Styles */
.v-card {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.v-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px -5px rgba(0, 0, 0, 0.1) !important;
}

/* Dialog Styles */
.v-dialog .v-card {
  border-radius: 16px !important;
}

.v-dialog .v-card-title {
  background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

/* Button Styles */
.v-btn {
  text-transform: none !important;
  letter-spacing: 0 !important;
  font-weight: 600;
}

.v-btn.v-btn--outlined {
  border-width: 2px;
}

/* Tab Styles */
.v-tabs .v-tab {
  text-transform: none !important;
  font-weight: 600;
  letter-spacing: 0;
}

.v-tabs .v-tab--active {
  background: rgba(var(--v-primary-base), 0.05);
}

/* Form Field Styles */
.v-text-field.v-text-field--outlined fieldset {
  border-radius: 8px;
}

/* Table Styles */
.v-simple-table thead th {
  background: #f8fafc !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  font-size: 11px !important;
  letter-spacing: 0.05em;
}

.v-simple-table tbody tr:hover {
  background: rgba(25, 118, 210, 0.04) !important;
}

/* Legacy gradient background */
#fondo {
  background-image: linear-gradient(135deg,
      #e9f6ff,
      #fff2f9,
      #efe9f7,
      #f2d8f1,
      #a950a1,
      #ff7cae);
  background-size: 500%;
}

/* Switch Styles */
.v-input--switch .v-label {
  font-size: 14px;
  color: #616161;
}

/* Autocomplete Styles */
.v-autocomplete .v-input__control {
  border-radius: 8px;
}

/* Animation */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-in {
  animation: fadeInUp 0.4s ease-out;
}
</style>